import * as React from 'react';
import * as inf from "./style.module.scss";
import data from "./data.json";
import { PhotoReviews } from "../../../../PhotoReviews";
export const Influencers = () => {
  return (
    <section className={inf.inf}>
      <div className="container">
        <h2>Нам доверяют лидеры мнений</h2>
        <PhotoReviews
          data={data}
          buttonsColor={"#9C87D9"}
          rowClassName={inf.photosRow}
          textClassName={inf.name}
        />
      </div>
    </section>
  );
};
